import type {
  InvalidConfigError,
  MessageFormatError,
  MissingDataError,
  MissingTranslationError,
  UnsupportedFormatterError,
} from 'react-intl';
import type { FormatError } from 'intl-messageformat';

import { IntlProvider, ReactIntlErrorCode } from 'react-intl';

const customIntlOnError = (
  err:
    | MissingTranslationError
    | MessageFormatError
    | MissingDataError
    | InvalidConfigError
    | UnsupportedFormatterError
    | FormatError
) => {
  if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
    console.warn(`[Intl Error] Missing translation for key: ${err.descriptor?.id}`);
  } else {
    IntlProvider.defaultProps.onError?.(err);
  }
};

export default customIntlOnError;
